__turbopack_context__.v({
  "tabsList": "index-module__KniMea__tabsList",
  "tabsSelect": "index-module__KniMea__tabsSelect",
  "tabsTrigger": "index-module__KniMea__tabsTrigger",
});
